/*
  언어 경로 규칙의 SSOT. head 에서 동기 로드된다 — theme.liquid 404 안전망이 파싱 즉시
  써야 하고 theme.js 는 defer 라 그때 없다.

  🔴 Weglot 이 주입된 링크 **앞에** 접두사를 또 붙인다. 앞이 오염, 뒤가 원본 의도다.
     서버도 뒤로 해석한다 (/tw/ja/... -> lang="ja"). 그래서 마지막 하나만 남긴다.
     local/i18n/2026-09-07-weglot-double-prefix-rootcause.md
*/
window.VerishLocale = (function () {
  // 언어를 추가하면 아래 두 정규식을 같이 고친다. 사본은 이 파일 안에만 있다.
  const CURRENT_PREFIX = /^\/(tw|ja)(?:\/|$)/;
  // /i 는 404 안전망용 — 대문자 경로로 들어와도 구해준다. current() 는 코드값을 그대로
  // 비교하므로 붙이지 않는다.
  const STACKED_PREFIXES = /^(?:\/(?:tw|ja)){2,}(?=\/|$)/i;

  function current(pathname) {
    const match = pathname.match(CURRENT_PREFIX);
    return match ? match[1] : 'en';
  }

  function normalize(pathname) {
    return pathname.replace(
      STACKED_PREFIXES,
      (stacked) => '/' + stacked.split('/').filter(Boolean).pop()
    );
  }

  function repairLink(link) {
    if (link.tagName !== 'A') return;

    const href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    let url;
    try {
      url = new URL(href, location.origin);
    } catch {
      return;
    }
    if (url.origin !== location.origin) return;

    const pathname = normalize(url.pathname);
    if (pathname === url.pathname) return;

    url.pathname = pathname;
    link.setAttribute(
      'href',
      /^[a-z][a-z\d+.-]*:\/\//i.test(href) ? url.href : url.pathname + url.search + url.hash
    );
  }

  function repairLinks(root) {
    if (root.nodeType !== 1) return;
    if (root.matches('a[href]')) repairLink(root);
    root.querySelectorAll('a[href]').forEach(repairLink);
  }

  // 컴포넌트마다 막으면 두더지잡기가 된다 — 주입 지점이 테마 18개 파일 + 서드파티 앱이다.
  // 문서 전체를 한 곳에서 감시하고, 클릭 순간 한 번 더 본다.
  function installGuard() {
    if (current(location.pathname) === 'en') return;

    const repairEventTarget = (event) => {
      const link = event.target?.closest?.('a[href]');
      if (link) repairLink(link);
    };
    // contextmenu 까지 보는 이유: 우클릭 새 탭·링크 주소 복사는 click 이 안 뜬다.
    ['click', 'auxclick', 'contextmenu'].forEach((type) =>
      document.addEventListener(type, repairEventTarget, true)
    );

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') repairLink(mutation.target);
        else mutation.addedNodes.forEach(repairLinks);
      });
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['href'],
      childList: true,
      subtree: true,
    });

    repairLinks(document.documentElement);
  }

  // 🔴 head 에서 바로 감시하면 초기 파싱 노드가 전부 콜백을 타서 파싱이 느려진다.
  //    DOM 이 다 선 뒤에 한 번 훑고 감시를 시작한다.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installGuard);
  } else {
    installGuard();
  }

  return { current, normalize, repairLink };
})();
